module.exports = __webpack_public_path__ + "img/hr-pump-east.af59699e.png";